export default __webpack_public_path__ + "static/media/close.c51fd928.svg";